var React = require('react');

function BookOpen (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z","key":0}),React.createElement("path",{"d":"M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z","key":1})]);
}

BookOpen.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-book-open"};

module.exports = BookOpen;

BookOpen.default = BookOpen;
